export default "__VITE_ASSET__BCeMt6vG__"